import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-metric",
  templateUrl: "./metric.component.html",
  styleUrls: ["./metric.component.scss"],
  standalone: false,
})
export class MetricComponent implements OnInit {
  @Input() label = "Metric";

  constructor() {}

  ngOnInit(): void {}
}
